import { useQuery } from '@tanstack/react-query'
import api from '@/lib/api'
import type { LprEventsResponse } from '@/types'

export interface UseLprEventsOptions {
  perPage?: number
  page?: number
  vehicleId?: number | null
  direction?: 'in' | 'out' | null
  capturedAtFrom?: string | null
  capturedAtTo?: string | null
  enabled?: boolean
  /** Polling interval in milliseconds. Set to 0 to disable. */
  refetchInterval?: number
}

export function useLprEvents({
  perPage = 20,
  page = 1,
  vehicleId,
  direction,
  capturedAtFrom,
  capturedAtTo,
  enabled = true,
  refetchInterval,
}: UseLprEventsOptions = {}) {
  return useQuery({
    queryKey: [
      'customer',
      'lpr_events',
      { perPage, page, vehicleId, direction, capturedAtFrom, capturedAtTo },
    ],
    queryFn: async () => {
      const params: Record<string, string | number> = { per_page: perPage, page }
      if (vehicleId != null) params.vehicle_id = vehicleId
      if (direction != null) params.direction = direction
      if (capturedAtFrom) params.captured_at_from = capturedAtFrom
      if (capturedAtTo) params.captured_at_to = capturedAtTo

      const response = await api.get<LprEventsResponse>('/api/customer/lpr_events', { params })
      return response.data
    },
    enabled,
    refetchInterval: refetchInterval ?? false,
  })
}
